import { createSlice } from '@reduxjs/toolkit'

const ticket = createSlice({
    name: 'ticket',
    initialState: {
        list: [],
        listLoaded: [],
        listMessage: [],
        listMessageLoaded: [],
        unreadList: []
    },
    reducers: {
        /*
        id_tab: 1-Активные; 0-Архивные;   
        id_status:
        1	Ожидание
        2	В работе
        3	Закрыт
        */

        load(state, action) {
            const id_status = action.payload.id_status;
            const id_tab = id_status === 3 ? 0 : 1;

            const list = action.payload.list;
            state.list = [...state.list.filter(a => a.id_status !== id_status), ...list.map((item) => { return { ...item, id_tab: id_tab } })].sort((a, b) => b.ID_Ticket - a.ID_Ticket);
            state.listLoaded = [...state.listLoaded.filter(a => a.id_status !== id_status), { id_status: id_status }];
        },
        add(state, action) {
            const model = action.payload.model

            const id_status = model.ID_Status;
            const id_tab = id_status === 3 ? 0 : 1;
            console.log('model', model);
            state.list = [...state.list, { ...model, id_tab: id_tab }].sort((a, b) => b.ID_Ticket - a.ID_Ticket);
        },

        messageLoad(state, action) {
            const id_ticket = action.payload.id_ticket;
            const list = action.payload.list;

            //console.log()

            state.listMessage = [...state.listMessage.filter(a => a.ID_Ticket !== id_ticket), ...list].sort((a, b) => b.ID_Message - a.ID_Message);
            state.listMessageLoaded = [...state.listMessageLoaded.filter(a => a.id_ticket !== id_ticket), { id_ticket: id_ticket }];
        },
        messageAdd(state, action) {
            const model = action.payload.model;
            const id_ticket = model.ID_Ticket;

            if (state.listMessageLoaded.filter(a => id_ticket).length > 0) {
                state.listMessage = [...state.listMessage, model].sort((a, b) => b.ID_Message - a.ID_Message);
            }
        },
        unreadLoad(state, action) {
            const data = action.payload.data;
            state.unreadList = data;
        },
    }
})

export const { load, add, messageLoad, messageAdd, unreadLoad } = ticket.actions
export default ticket.reducer